import { render } from "./COIActionBarPostalReturn.vue?vue&type=template&id=5ad28886&scoped=true"
import script from "./COIActionBarPostalReturn.vue?vue&type=script&lang=js"
export * from "./COIActionBarPostalReturn.vue?vue&type=script&lang=js"

import "./COIActionBarPostalReturn.vue?vue&type=style&index=0&id=5ad28886&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad28886"]])

export default __exports__